import { AxiosResponse } from "axios";
import { apiInstance } from "@/store/configureStore";
import { IMoodCalendarStatePending } from "./reducers";

export const getMoodCalendarRequest = async (
  params: IMoodCalendarStatePending
) => {
  const response: AxiosResponse = await apiInstance.get("/mood-monitoring", {
    params: {
      ...params,
    },
  });

  return response.data;
};
